import { sippy } from "../../package";

const urls = {
  api: `https://api.sippy.cloud/v${sippy.api}`,
  nextApi: `https://api.sippy.cloud/v${sippy.nextApi}`,
  ws: `wss://api.sippy.cloud/websocket`,
  docs: "https://docs.sippy.cloud/",
  audio: `https://firebasestorage.googleapis.com/v0/b/optimisevoip-audio/o/`,
  image: `https://firebasestorage.googleapis.com/v0/b/sippy-images/o/provisioning%2F`,
  phonebook: "https://provisioning.sippy.cloud/phonebook",
  gsAudio: "gs://optimisevoip-audio",
  gsImages: "gs://sippy-images",
};

if (import.meta.env.SIPPY_ENV === "staging") {
  urls.api = `https://api.staging.sippy.be/v${sippy.api}`;
  urls.nextApi = `https://api.staging.sippy.be/v${sippy.nextApi}`;
  urls.ws = `wss://api.staging.sippy.be/websocket`;
  urls.docs = "https://fake-docs.firebaseapp.com/";
  urls.audio = "https://firebasestorage.googleapis.com/v0/b/sippy-platform-staging-audio/o/";
  urls.image = "https://firebasestorage.googleapis.com/v0/b/sippy-platform-staging-images/o/provisioning%2F";
  urls.phonebook = "https://provisioning.sippy.be/phonebook";
  urls.gsAudio = "gs://sippy-platform-staging-audio";
  urls.gsImages = "gs://sippy-platform-staging-images";
}

if (import.meta.env.SIPPY_ENV === "dev" || import.meta.env.SIPPY_ENV === "docs") {
  urls.api = `http://localhost:4567/v${sippy.api}`;
  urls.nextApi = `http://localhost:4567/v${sippy.nextApi}`;
  urls.ws = `ws://127.0.0.1:4567/websocket`;
  urls.docs = "http://localhost:5173/";
  urls.audio = "https://firebasestorage.googleapis.com/v0/b/sippy-platform-staging-audio/o/";
  urls.image = "https://firebasestorage.googleapis.com/v0/b/sippy-platform-staging-images/o/provisioning%2F";
  urls.phonebook = "https://provisioning.sippy.be/phonebook";
  urls.gsAudio = "gs://sippy-platform-staging-audio";
  urls.gsImages = "gs://sippy-platform-staging-images";
}

export default urls;
